import React from 'react';
import { useTheme } from '../context/ThemeContext';

const CustomTooltip = ({ active, payload, label }) => {
  const { isDarkMode } = useTheme();

  if (active && payload && payload.length) {
    // Filter to show only valid (non-null, non-NaN) values
    const validPayload = payload.filter(entry =>
      entry.value !== null && entry.value !== undefined && !isNaN(entry.value)
    );

    if (validPayload.length === 0) return null;

    // Show all valid items at this data point
    const itemsToShow = validPayload;

    return (
      <div
        className="p-4 rounded-xl shadow-2xl font-medium border"
        style={{
          background: isDarkMode ? 'rgba(23, 23, 23, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          boxShadow: isDarkMode
            ? '0 8px 32px 0 rgba(0, 0, 0, 0.6)'
            : '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
          borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)',
          color: isDarkMode ? '#fafafa' : '#1f2937'
        }}
      >
        <p
          className="text-lg font-semibold mb-2"
          style={{ color: isDarkMode ? '#fafafa' : '#111827' }}
        >
          {`Documents: ${label}`}
        </p>
        {itemsToShow.map((entry, index) => {
          const displayDataKey = entry.name || entry.dataKey;
          return (
            <p key={index} className="text-base mb-1 flex items-center" style={{ color: entry.color }}>
              <span
                className="inline-block w-3 h-3 rounded-full mr-2 shadow-sm"
                style={{ backgroundColor: entry.color }}
              />
              <span className="font-medium">{displayDataKey}:</span>
              <span className="ml-2 font-bold">{entry.value?.toFixed(2)}</span>
            </p>
          );
        })}
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
